<!--
 * @Author: your name
 * @Date: 2021-06-22 13:58:42
 * @LastEditTime: 2021-08-30 15:21:24
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \ecfc-oms-facade\src\views\home\components\EcHeaderLogout.vue
-->
<template>
  <div class="in-passWordChange">
    <div class="in-changePW flex-center" @click="logout">
      <!-- <ec-svg-icon icon-class="icon-tuichu"></ec-svg-icon> -->
      <!-- <p>{{ $t('navbar.logOut') }}</p> -->
      <ec-svg-icon icon-class="icon-tuichu"></ec-svg-icon>
      <p>登出</p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      roleNames:"",
      name: 'EcHeaderLogout',
      fit: 'contain',
    }
  },
  inject: ['maxInactiveInterval', 'lastActiveTimeFn'],
  computed: {
    lastActiveTime () {
      return this.lastActiveTimeFn()
    }
  },
  created(){
    this.roleNames = this.$store.state.roleNames.toString()
  },
  methods: {
    logout() {  
      const _this = this
      let currentActiveTime = new Date().getTime()
      if (currentActiveTime - _this.lastActiveTime > // 超时
        _this.maxInactiveInterval) {
        console.log('超时')
      } else {
        _this
          .$confirm(_this.$t('prompt.outTips'), _this.$t('prompt.prompt'), {
            confirmButtonText: _this.$t('button.determine'),
            cancelButtonText: _this.$t('button.cancel'),
            type: 'warning'
          })
          .then(async() => {
            const { success } = await _this.Api.loginOut()
            if (success) {
              _this.$store.commit('SET_LOGIN', false)
              if (_this.$store.state.permissUpdateFlag) {
                // 如果修改了权限则退出到登录页面时清空路由
                _this.$router.go(0)
              } else {
                _this.$router.push({ path: '/login' })
              }
            }
          })
          .catch(() => {})
      }
    }
  }
}
</script>

<style>
  .col-center{
    display:flex;
    justify-content:center;/*主轴上居中*/
    align-items:center;/*侧轴上居中*/
    margin-top: 5px;
  }
  .col-left{
    display:flex;
    justify-content:left;/*主轴上居中*/
    align-items:center;/*侧轴上居中*/
    margin-top: 5px;
    font-size: 15px;
  }
  .p-size{
    font-size: 10px;
    margin-left: 3px;
  }
  .el-divider{
    margin: 0 0;
    border-top: 1px solid;
  }
</style>


// WEBPACK FOOTER //
// src/views/home/components/EcHeaderLogout.vue